import { useState } from "react";
import { ZoomIn, FileText, Download } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { useFileUrl } from "./AuthImage";

export const ReceiptPreview = ({ path, testId, className = "h-40 w-40" }) => {
  const [open, setOpen] = useState(false);
  const { url, type } = useFileUrl(path);
  if (!path) return <div className={`flex items-center justify-center rounded-xl border text-center text-xs text-muted-foreground ${className}`} data-testid={`${testId}-none`}>No receipt</div>;
  if (type === "application/pdf")
    return <a href={url} target="_blank" rel="noreferrer" className={`flex flex-col items-center justify-center gap-1 rounded-xl border text-xs ${className}`} data-testid={testId}><FileText className="h-6 w-6" />PDF</a>;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className={`group relative shrink-0 overflow-hidden rounded-xl border bg-muted ${className}`} data-testid={testId}>
        {url && <img src={url} alt="Payment receipt" className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />}
        <span className="absolute bottom-1.5 right-1.5 rounded-full bg-black/60 p-1"><ZoomIn className="h-4 w-4 text-white" /></span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-4xl" aria-describedby={undefined} data-testid={`${testId}-dialog`}>
          <DialogTitle className="font-serif text-2xl">Payment receipt</DialogTitle>
          <img src={url} alt="Payment receipt" className="max-h-[75vh] w-full rounded-lg object-contain" data-testid={`${testId}-large`} />
          <a href={url} download="receipt" className="btn-ghost-gold w-fit" data-testid={`${testId}-download`}><Download className="h-4 w-4" />Download</a>
        </DialogContent>
      </Dialog>
    </>
  );
};
